import {
  GET_ADMIN_REFUND_REASON,
  GET_ADMIN_REFUND_REASON_SUCCESS,
  POST_ADMIN_REFUND_REASON,
  POST_ADMIN_REFUND_REASON_SUCCESS,
  POST_ADMIN_REFUND_REASON_ERROR,
  UPDATE_ADMIN_REFUND_REASON,
  UPDATE_ADMIN_REFUND_REASON_SUCCESS,
  UPDATE_ADMIN_REFUND_REASON_ERROR,
  DELETE_ADMIN_REFUND_REASON,
  DELETE_ADMIN_REFUND_REASON_SUCCESS,
  DELETE_ADMIN_REFUND_REASON_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  admin_refund_reason: [],
  loading: false,
  error: "",
}
const AdminRefundReasons = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ADMIN_REFUND_REASON:
      return {
        ...state,
        loading: true,
      }

    case GET_ADMIN_REFUND_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_refund_reason: action.payload,
      }

    case POST_ADMIN_REFUND_REASON:
      return {
        ...state,
        loading: true,
      }

    case POST_ADMIN_REFUND_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_refund_reason: [...state.admin_refund_reason, action.payload],
      }

    case POST_ADMIN_REFUND_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    case UPDATE_ADMIN_REFUND_REASON:
      return {
        ...state,
        loading: true,
      }

    case UPDATE_ADMIN_REFUND_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_refund_reason: state.admin_refund_reason.map((item) => { 
          if (item.id === action.payload.id) {
            return action.payload
          }
          return item
        }),
      }

    case UPDATE_ADMIN_REFUND_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
      
    case DELETE_ADMIN_REFUND_REASON:
      return {
        ...state,
        loading: true,
      }

    case DELETE_ADMIN_REFUND_REASON_SUCCESS:
      return {
        ...state,
        loading: false,
        admin_refund_reason: state.admin_refund_reason.filter((item) => item.id !== action.payload.id),
      }

    case DELETE_ADMIN_REFUND_REASON_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default AdminRefundReasons;
